import { defineStore } from "pinia";
import { ref } from "vue";
import mentionsService from "@/services/mentionsService";
import usersService from "@/services/usersService";

export const useInboxStore = defineStore("inbox-store", () => {
  const unreadCount = ref(0);
  const teammates = ref([]);
  const arrival = ref(null);
  let teammatesLoaded = false;
  let countInitialized = false;

  async function fetchUnreadCount() {
    try {
      const { count } = await mentionsService.getUnreadCount();
      const previous = unreadCount.value;
      unreadCount.value = count;
      if (countInitialized && count > previous) {
        let latest = null;
        try {
          const { results } = await mentionsService.listMentions(1);
          latest = results.find((m) => !m.readAt) || null;
        } catch {
          // Generic toast without sender detail.
        }
        arrival.value = { delta: count - previous, mention: latest };
      }
      countInitialized = true;
    } catch {
      // Badge freshness is best-effort — keep the last known count.
    }
  }

  function clearArrival() {
    arrival.value = null;
  }

  async function reconcileUnreadCount() {
    try {
      const { count } = await mentionsService.getUnreadCount();
      unreadCount.value = count;
    } catch {
      // Badge freshness is best-effort — keep the last known count.
    }
  }

  function setUnreadCount(count) {
    if (typeof count === "number") unreadCount.value = count;
  }

  async function fetchTeammates({ force = false } = {}) {
    if (teammatesLoaded && !force) return teammates.value;
    const { results } = await usersService.listTeammates();
    teammates.value = results;
    teammatesLoaded = true;
    return teammates.value;
  }

  return {
    unreadCount,
    teammates,
    arrival,
    fetchUnreadCount,
    reconcileUnreadCount,
    setUnreadCount,
    fetchTeammates,
    clearArrival,
  };
});
